import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "font-roboto h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-center text-4xl font-light text-gray-900" }, " Unustasid parooli? ", -1)
const _hoisted_4 = { class: "text-sm text-center mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6 sm:mx-auto sm:w-full sm:max-w-md"
}
const _hoisted_6 = { class: "bg-white py-8 px-4 shadow sm:rounded-md sm:px-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "forgot-password-email",
  class: "block text-base font-normal text-gray-800"
}, " E-mail ", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-base font-normal text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
  }, " Taasta parool ")
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "mt-4 max-w-3xl mx-auto text-center text-xl text-gray-800" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" E-mailile ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" on saadetud kiri, kus saate enda parooli vahetada! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toHomePage())),
          class: "font-medium text-blue-600 hover:text-blue-500 transition duration-500 ease-in-out cursor-pointer"
        }, " Sisse logimine ")
      ])
    ]),
    (!_ctx.emailSent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "space-y-6",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onForgotPassword && _ctx.onForgotPassword(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    id: "forgot-password-email",
                    name: "email",
                    type: "email",
                    autocomplete: "email",
                    required: "",
                    class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring-0 focus:border-blue-500 focus:outline-none sm:text-sm",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _hoisted_9
            ], 32)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("strong", null, _toDisplayString(_ctx.email), 1),
            _hoisted_13
          ]),
          _createElementVNode("p", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toHomePage())),
            class: "mt-4 max-w-3xl mx-auto text-center text-xl text-gray-500 hover:text-blue-500 transition duration-500 ease-in-out cursor-pointer"
          }, " Tagasi pealehele (" + _toDisplayString(_ctx.counter) + ") ... ", 1)
        ]))
  ]))
}